import { ReactComponent as Icon } from "../assets/icons/chats/Videocall.svg";
import genIcons from "./genIcons";

const Videocall = { Outline: genIcons(Icon, { htmlColor: "transparent" }) };

export default Videocall;
